/**
 * Created by Vladislav on 12.08.2026.
 */

class AlignmentComponent extends BaseComponent {
    onCreate() {
        this.alignment = this.options.alignment;
    }

    setAlignment(alignment) {
        this.alignment = alignment;
        delete this.context;

        if (this.node.parent) {
            this.apply();
        }
    }

    apply() {
        if (this.alignment === undefined) {
            return;
        }

        const position = this.node.positionFromAlignment(this.alignment);
        this.node.setPosition(position.x, position.y);
    }

    // resolved here and not in the constructor - components are created in json key order,
    // so a "#Controller.getPosition" alignment can name a component that does not exist yet
    onAttach() {
        if (this.context) {
            this.alignment = PrefabBuilder.resolveProperty(this.alignment, this.context);
            delete this.context;
        }

        if (this.node.parent) {
            this.apply();
        }
    }

    onParented() {
        this.apply();
    }

    onParentSizeChanged() {
        this.apply();
    }

    onResize() {
        const mode = cleverapps.resolution.mode;
        if (mode === this.mode) {
            return;
        }

        if (Array.isArray(this.alignment)) {
            this.apply();
        }

        this.mode = mode;
    }
}

Prefab.registerComponent("AlignmentComponent", {
    alignment: {
        type: "alignment",
        editorDefault: { x: { align: "center" }, y: { align: "center" } },
        getter: (component) => component.alignment,
        setter: (component, value, context) => component.setAlignment(PrefabBuilder.resolveProperty(value, context))
    }
}, AlignmentComponent);
